// @flow
import React from 'react';
import { pure } from 'recompose';
import { FormattedNumber } from 'react-intl';
import ReactImageFallback from 'react-image-fallback';
import ReactTruncate from 'react-truncate';
import { RatingDisplay } from 'angieslist-react-components';
import './dealCard.scss';
import type { Deal } from '../../types';

const defaultDealCardImage = require('../../assets/default-deal-img.jpg');

type Props = {
  deal: Deal,
};

const DealCardComponent = ({
  deal,
}: Props) => (
  <div className="deal-card">
    <div
      className="deal-card_image-container"
      id={`deal-card--image-${deal.id}`}
    >
      <ReactImageFallback
        src={deal.imageUrl}
        fallbackImage={defaultDealCardImage}
        alt="product"
      />
    </div>
    <div className="deal-info">
      <div
        id={`deal-card--title-${deal.id}`}
        className="deal-card_body"
      >
        <div
          id={`deal-card--title-${deal.id}`}
          className="deal-card_title-container"
        >
          <div className="deal-card_title" title={deal.title}>
            <ReactTruncate lines={2}>
              {deal.title}
            </ReactTruncate>
          </div>
        </div>
      </div>
      <div
        id={`deal-card--price-${deal.id}`}
        className="deal-card_price-container"
      >
        <div className="deal-card_info-left">
          <div className="deal-card_price_container">
            <span className="deal-card_member-price">
              <If condition={deal.memberPrice !== undefined}>
                <FormattedNumber
                      // eslint-disable-next-line react/style-prop-object
                  style="currency"
                  currency="USD"
                  minimumFractionDigits={deal.memberPrice % 1 !== 0 ? 2 : 0}
                  value={deal.memberPrice}
                />
              </If>
            </span>
            <If condition={deal.memberPrice / deal.originalPrice < 0.9}>
              <br />
              <span className="deal-card_original-price">
                <If condition={deal.originalPrice !== undefined}>
                  <FormattedNumber
                        // eslint-disable-next-line react/style-prop-object
                    style="currency"
                    currency="USD"
                    minimumFractionDigits={deal.originalPrice % 1 !== 0 ? 2 : 0}
                    value={deal.originalPrice}
                  />
                </If>
              </span>
            </If>
          </div>
        </div>
        <div className="deal-card_info-right" >
          <RatingDisplay
            customId="deal-card_rating-display"
            rating={deal.serviceProvider.starRating}
            starSize="0.8em"
            ratingFontSize="1.8em"
            ratingLocation="top"
          />
          <br />
        </div>
      </div>
    </div>
  </div>
);

export default (pure(DealCardComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/DealCard.js